import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoleManagerService {

  constructor(private http: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string) { }

  getAllRoles() {
    return this.http.post(this.apiEndPoint + '/gwdevice/configparam/_search?size=1000', {"query":{},"sort":[{"_kuzzle_info.createdAt":"desc"}]});

  }
  getRoleDetails(user_type: any){
   // return this.http.get('assets/asstes.json');
   return this.http.get(this.apiEndPoint + '/gwdevice/configparam/' + user_type );

  }
  roleUpdate(pages: any, id: any, visibility?:any){
    return this.http.put(this.apiEndPoint + '/gwdevice/configparam/' + id + '/_update', {pages, visibility});
  }
  roleCreate(pages: any, id: any){
    return this.http.post(this.apiEndPoint + '/gwdevice/configparam/' + id + '/_create', {
      "type": "user_role",
      "pages": pages.pages,
      "profileIds": pages.profileIds,
      "visibility": pages.visibility
    });
  }

  getCurrentUser() {
        return this.http.get(`${this.apiEndPoint}/_me`)
    }

}
